import ROUTES from "src/js/router/routes";
import { SelectionIdentifier, SelectionType } from "src/js/stores/map/store";
import { Geometry } from "react-migration/domains/sites/typings";
import { calculateZoomLevel } from "./calculateZoomLevel";

type getMapSiteSelectionRouterLocationProps = {
  siteLatLng: {
    lat: number;
    lng: number;
  };
  geometry: Geometry;
  siteId: string;
};

type MapSiteSelectionLocation = {
  name: string;
  params: { z: string; x: string; y: string };
  query: {
    selectionType: SelectionType;
    selectionId: string;
  };
};

export const getMapSiteSelectionLocation = ({
  siteLatLng,
  geometry,
  siteId,
}: getMapSiteSelectionRouterLocationProps): MapSiteSelectionLocation => {
  const zoomLevel = calculateZoomLevel(geometry);

  return {
    name: ROUTES.MAP,
    query: {
      selectionType: SelectionType.SITE,
      selectionId: siteId!,
    },
    params: {
      z: String(zoomLevel + 1),
      x: String(siteLatLng.lat),
      y: String(siteLatLng.lng),
    },
  };
};
